import { Tooltip } from "react-tooltip";
import { formatToNaira } from "../../utils/helpers";
import { Icon } from "../icon/icon";
import { RenderMarkdown } from "../typography/renderMarkdown";
import { BgWrapper } from "../wrapper/bgWrapper";

export const NumberCard = ({
  value,
  text,
  isCurrency = true,
  tooltipId,
  tooltipText,
}: {
  value: number;
  text: string;
  isCurrency?: boolean;
  tooltipId?: string;
  tooltipText?: string;
}) => {
  return (
    <BgWrapper className="flex flex-col gap-1 border border-grey-200">
      <p className="text-[20px] font-extrabold md:text-2xl">
        {isCurrency ? formatToNaira(value) : value.toLocaleString()}
      </p>
      <p className="flex items-center gap-1 text-sm capitalize text-grey-600 md:text-base">
        {text}
        {tooltipId && (
          <span id={`${tooltipId}`}>
            <Icon width={20} height={20} svg="info" />
          </span>
        )}
      </p>

      <Tooltip anchorSelect={`#${tooltipId}`} className="tooltip">
        <RenderMarkdown>{tooltipText}</RenderMarkdown>
      </Tooltip>
    </BgWrapper>
  );
};
